/**
 * Liest eine hochgeladene CSV-Datei als Text: UTF-8 (mit oder ohne BOM), sonst Windows-1252 --
 * Excel speichert "CSV (Trennzeichen-getrennt)" je nach Version in einem von beiden.
 */
export async function readFileText(file: Blob): Promise<string> {
  const buffer = await new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(reader.error ?? new Error('Datei konnte nicht gelesen werden'));
    reader.readAsArrayBuffer(file);
  });
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(buffer);
  } catch {
    return new TextDecoder('windows-1252').decode(buffer);
  }
}
